import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import type { Order } from '@bharat-consultancy/shared';

export function useOrders() {
  const [orders, setOrders] = useState<Order[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(() => {
    setIsLoading(true);
    return api.orders
      .list()
      .then((res) => setOrders(res.orders))
      .catch((err) => setError(err))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { orders, isLoading, error, refetch };
}
